import { render, staticRenderFns } from "./set12.vue?vue&type=template&id=3e79db00&scoped=true&"
import script from "./set12.vue?vue&type=script&lang=js&"
export * from "./set12.vue?vue&type=script&lang=js&"
import style0 from "./set12.vue?vue&type=style&index=0&id=3e79db00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e79db00",
  null
  
)

export default component.exports